import React, { useContext, useEffect, useState } from 'react';
import { ChatStateContext } from '../../contexts/chatStateContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { LangContext } from '../../contexts/langContext';

export const ChatsNotifications = React.memo(({ listId, actions = [], avatar = {}, user = {}, penta = {} }) => {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) }
  const chatState = useContext(ChatStateContext);

  const [notiCount, setNotiCount] = useState(0);

  useEffect(() => {
    if (chatState.unread) {
      const totalCount = chatState.unread.length 
        ? chatState.unread.reduce((accumulator, item) => accumulator + item.count, 0)
        : 0;
      setNotiCount(totalCount);
    }
  }, [chatState.unread])

  const handleClick = () => {
    if (chatState.unread && chatState.unread.length) {
      chatState.setCurrentChat(chatState.unread[0]._id);
    } else {
      chatState.setCurrentChat('choose');
    }
  }




  return (<>


    {/* <WithVersion> */}
    <div className="x_user0"
      onClick={() => handleClick()}
    >

      {Boolean(notiCount) && <div className="x_noti0 x_noti0--number"><div className="x_noti0_number">{notiCount}</div></div>}

      <div className="t_icon t_icon--60" style={{ opacity: Boolean(notiCount) ? 1 : 0.4 }}>
        chat_bubble
      </div>
    </div>
    {/* </WithVersion> */}

    {/* <DropDown
      id='noti'
      options={[
        // { component: <LangSwitcher /> },
        {
          id: 'allread',
          // active: context.language === 'en',
          icon: 'check',
          // title: 'English',
          handle: () => markAllRead(),
          className: `x_menu_li x_menu_markallread ${Boolean(notifications.filter(one => !one.read).length) ? '' : 'x_menu_li--noti inactive'}`,
          component: <> {Boolean(notiCount.new) && <div>Mark all as read</div>} {!Boolean(notiCount.new) && <div>No notifications yet</div>}</>
        },

        ...notis

      ]}

    >
      <div className="x_user0">

        {Boolean(notiCount.new) && <div className="x_noti0 x_noti0--number"><div className="x_noti0_number">{notiCount.new}</div></div>}

        <div className="t_icon t_icon--60" style={{ opacity: Boolean(notiCount.new) ? 1 : 0.4 }}>
          notifications
        </div>
      </div>
    </DropDown> */}
  </>
  )
})